import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ServiceCategoriesBusinessService } from '../../business-services/service-categories-business.service';


@Injectable({ providedIn: 'root' })
export class EditServiceCategoryGuard  {

  constructor(
    private serviceCategoriesService: ServiceCategoriesBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.serviceCategoriesService.serviceCategoryId) {
      return true;
    }
    return this.router.createUrlTree(['/service-categories']);
  }
}
